import { render, staticRenderFns } from "./ManualBoarding.vue?vue&type=template&id=63c9c9c4&scoped=true"
import script from "./ManualBoarding.vue?vue&type=script&lang=js"
export * from "./ManualBoarding.vue?vue&type=script&lang=js"
import style0 from "./ManualBoarding.vue?vue&type=style&index=0&id=63c9c9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9c9c4",
  null
  
)

export default component.exports